export const DEFAULT_COMPANY_SETTINGS = {
    tdsEnabled: false,
    dueDateReminderDays: 0,
    ledgerRequired: false,
    loanReleaseDays: 7,
};
/** Common preset reminder options for the UI */
export const DUE_DATE_REMINDER_OPTIONS = [
    { value: 0, label: 'Off (no reminders)' },
    { value: 1, label: '1 day before' },
    { value: 2, label: '2 days before' },
    { value: 3, label: '3 days before' },
    { value: 5, label: '5 days before' },
    { value: 7, label: '7 days before' },
    { value: 14, label: '14 days before' },
];
/** The reminders popup lists at most this many invoices, the most urgent first. */
export const DUE_REMINDER_ITEM_LIMIT = 200;
export const DUE_DATE_REMINDER_SETTING = {
    key: 'dueDateReminderDays',
    label: 'Due-date reminder scheduler',
    description: 'Displays a top notification banner for invoices that are overdue or due within the selected number of days before their due date. Set to Off to disable.',
    options: DUE_DATE_REMINDER_OPTIONS,
};
/** When loan EMIs are released into the Payment Queue, or set to await the bank's debit. */
export const LOAN_RELEASE_SETTING = {
    key: 'loanReleaseDays',
    label: 'Release loan EMIs',
    description: 'How many days before its due date a loan EMI enters the payment flow: a bank-transfer EMI goes into the Payment Queue, an auto-debit EMI waits for the bank’s debit. It then also shows in Accounts Payable.',
    options: [
        { value: 3, label: '3 days before' },
        { value: 5, label: '5 days before' },
        { value: 7, label: '7 days before' },
        { value: 10, label: '10 days before' },
        { value: 15, label: '15 days before' },
        { value: 30, label: '30 days before' },
    ],
};
/** What System Settings lists for feature switches, in order: one row per setting. */
export const COMPANY_SETTINGS_CATALOGUE = [
    {
        key: 'tdsEnabled',
        label: 'TDS calculation on invoices',
        description: 'Proposes TDS from the vendor master when an invoice is uploaded, lets the accounting team set TDS lines, and shows TDS and the net payable on each invoice. Off, invoices show their total and are paid in full.',
        indiaOnly: true,
    },
    {
        key: 'ledgerRequired',
        label: 'Require ledgers at verification',
        description: 'Accounting must confirm the expense ledger before releasing an invoice. It arrives pre-filled from the ledger suggested at review, else the vendor’s default. Off, ledgers are offered but optional — turn it on once the chart of accounts is set up under General Ledgers.',
    },
];
/** A company's settings, with defaults filled in for any it has never saved. */
export function companySettingsOf(company) {
    return { ...DEFAULT_COMPANY_SETTINGS, ...(company.settings ?? {}) };
}
//# sourceMappingURL=companySettings.js.map